import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getInterviewRoles,
  getInterviewQuestionByRoleId,
  addOrUpdateQuestions,
  deleteQuestion,
  deleteMultipleQuestion,
  addOrupdateInterviewRoles,
  deleteRole
} from "./InterviewApi";

const initialState: any = {
  loading: {
    getRole: false,
    addRole: false,
    deleteRole: false,
    get: false,
    add: false,
    delete: false,
  },
  req_success: {
    getRole: false,
    addRole: false,
    deleteRole: false,
    get: false,
    add: false,
    delete: false,
  },
  edit: false,
  editRole: false,
  singleRole: {},
  singleData: {},
  all_roles: [],
  temp_roles: [],
  all_questions: [],
  questions: [],
};

const AdminInterview = createSlice({
  name: "AdminInterview",
  initialState,
  reducers: {
    editInterview: (state: any, { payload }: PayloadAction<any>) => {
      state.edit = true;
      state.singleData = payload;
    },
    closeInterviewModal: (state: any) => {
      state.edit = false;
      state.singleData = {};
    },
    setEditRole: (state: any, { payload }: PayloadAction<any>) => {
      state.editRole = true;
      state.singleRole = payload;
    },
    closeAddInterviewRoleModal: (state: any) => {
      state.editRole = false;
      state.singleRole = {};
    },

    searchInterview: (state: any, { payload }: PayloadAction<any>) => {
      if (payload.length > 1) {
        state.questions = state.all_questions.filter((plan: any) =>
          plan.question.toLowerCase().includes(payload.toLowerCase())
        );
      } else {
        state.questions = state.all_questions;
      }
    },
  },
  extraReducers: (builder) => {
    // GET ALL INTERVIEW ROLES
    builder.addCase(getInterviewRoles.pending, (state) => {
      state.loading.getRole = true;
      state.req_success.getRole = false;
    });
    builder.addCase(
      getInterviewRoles.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.getRole = false;
        state.req_success.getRole = true;
        state.temp_roles = payload?.data;
        state.all_roles = payload?.data;
      }
    );
    builder.addCase(getInterviewRoles.rejected, (state) => {
      state.loading.getRole = false;
    });

    // ADD  OR UPDATE INTERVIEW ROLES
    builder.addCase(addOrupdateInterviewRoles.pending, (state) => {
      state.loading.addRole = true;
      state.req_success.addRole = false;
    });
    builder.addCase(
      addOrupdateInterviewRoles.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.addRole = false;
        state.req_success.addRole = true;
        state.editRole = false;
        // console.log(payload);
            // Check if it's an update or new addition
            if (payload?.idForUpdate > 0) {
              state.temp_roles = state.temp_roles.map((role: any) =>
                role.id === payload.data.id ? payload.data : role
              );
            } else {
              state.temp_roles = [...state.temp_roles, payload.data];
            }
            state.all_roles = state.temp_roles; 
      }
    );
    builder.addCase(addOrupdateInterviewRoles.rejected, (state) => {
      state.loading.addRole = false;
      state.req_success.addRole = false;
    });

        // DELETE  INTERVIEW ROLE
        builder.addCase(deleteRole.pending, (state) => {
          state.loading.deleteRole = true;
          state.req_success.deleteRole = false;
        });
        builder.addCase(
          deleteRole.fulfilled,
          (state, { payload }: PayloadAction<any>) => {
            state.loading.deleteRole = false;
            state.req_success.deleteRole = true;
            state.editRole = false;
          }
        );
        builder.addCase(deleteRole.rejected, (state) => {
          state.loading.deleteRole = false;
          state.req_success.deleteRole = false;
        });

    // GET ALL QUESTIONS AND ANSWERS BY ROLE ID
    builder.addCase(getInterviewQuestionByRoleId.pending, (state) => {
      state.loading.get = true;
      state.req_success.get = false;
    });
    builder.addCase(
      getInterviewQuestionByRoleId.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.get = false;
        state.req_success.get = true;
        state.questions = payload.data;
        state.all_questions = payload.data;
      }
    );
    builder.addCase(getInterviewQuestionByRoleId.rejected, (state) => {
      state.loading.get = false;
    });

    // ADD OR UPDATE QUESTIONS
    builder.addCase(addOrUpdateQuestions.pending, (state) => {
      state.loading.add = true;
      state.req_success.add = false;
    });
    builder.addCase(
      addOrUpdateQuestions.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.add = false;
        state.req_success.add = true;
        state.edit = false;
        if (payload?.idForUpdate > 0) {
          state.all_questions = state.all_questions.map((question: any) => {
            if (question.id === payload?.data.id) {
              return payload?.data;
            }
            return question;
          });
        }

        if (payload?.idForUpdate === 0) {
          state.all_questions = [...state.all_questions, payload?.data];
        }
        state.questions = state.all_questions;
      }
    );
    builder.addCase(addOrUpdateQuestions.rejected, (state) => {
      state.loading.add = false;
    });

    //  DELETE question
    builder.addCase(deleteQuestion.pending, (state) => {
      state.loading.delete = true;
      state.req_success.delete = false;
    });
    builder.addCase(
      deleteQuestion.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.delete = false;
        state.req_success.delete = true;
        // state.questions = state.questions.filter(
        //   (question: any) => question.id !== payload?.id
        // );

        // state.all_questions = state.all_questions.filter(
        //   (question: any) => question.id !== payload?.id
        // );
      }
    );
    builder.addCase(deleteQuestion.rejected, (state) => {
      state.loading.delete = false;
    });

    //  DELETE multiple question
    builder.addCase(deleteMultipleQuestion.pending, (state) => {
      state.loading.delete = true;
      state.req_success.delete = false;
    });
    builder.addCase(
      deleteMultipleQuestion.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.delete = false;
        state.req_success.delete = true;
      }
    );
    builder.addCase(deleteMultipleQuestion.rejected, (state) => {
      state.loading.delete = false;
    });
  },
});
export const { editInterview, closeInterviewModal, searchInterview, setEditRole, closeAddInterviewRoleModal } =
  AdminInterview.actions;
export default AdminInterview.reducer;
